// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Rating Component */
.rating {
  align-items: center;
  display: inline-flex;
  flex-direction: row;
}
.rating span {
  display: none;
}

.star {
  cursor: pointer;
  margin-inline: var(--ids-rating-star-margin-inline);
}

.star[icon=star-outlined] {
  color: var(--ids-rating-star-color-default);
}
.star[icon=star-outlined]:hover {
  color: var(--ids-rating-star-color-hover);
}
.star[icon=star-outlined]:focus-visible {
  outline: none;
  color: var(--ids-rating-star-color-focus);
}

.star[icon=star-filled] {
  color: var(--ids-rating-star-color-selected);
}
.star[icon=star-filled]:hover {
  color: var(--ids-rating-star-color-hover);
}
.star[icon=star-filled]:focus-visible {
  outline: none;
  color: var(--ids-rating-star-color-focus);
}

.star[icon=star-half] {
  color: var(--ids-rating-star-color-selected);
}
.star[icon=star-half]:hover {
  color: var(--ids-rating-star-color-hover);
}
.star[icon=star-half]:focus-visible {
  outline: none;
  color: var(--ids-rating-star-color-focus);
}
.star[icon=star-half]:dir(rtl) {
  transform: scaleX(-1);
}

:host([readonly]) .star {
  cursor: default;
  pointer-events: none;
}

:host([disabled]) .star {
  cursor: default;
  pointer-events: none;
}
:host([disabled]) .star[icon] {
  color: var(--ids-rating-star-disabled-color);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-rating/ids-rating.scss"],"names":[],"mappings":"AAAA,yBAAA;AAEA;EACE,mBAAA;EACA,oBAAA;EACA,mBAAA;AAAF;AAEE;EACE,aAAA;AAAJ;;AAIA;EACE,eAAA;EACA,mDAAA;AADF;;AAIA;EACE,2CAAA;AADF;AAGE;EACE,yCAAA;AADJ;AAIE;EACE,aAAA;EACA,yCAAA;AAFJ;;AAMA;EACE,4CAAA;AAHF;AAKE;EACE,yCAAA;AAHJ;AAME;EACE,aAAA;EACA,yCAAA;AAJJ;;AAQA;EACE,4CAAA;AALF;AAOE;EACE,yCAAA;AALJ;AAQE;EACE,aAAA;EACA,yCAAA;AANJ;AASE;EACE,qBAAA;AAPJ;;AAYE;EACE,eAAA;EACA,oBAAA;AATJ;;AAcE;EACE,eAAA;EACA,oBAAA;AAXJ;AAaI;EACE,4CAAA;AAXN","sourcesContent":["/* Ids Rating Component */\n\n.rating {\n  align-items: center;\n  display: inline-flex;\n  flex-direction: row;\n\n  span {\n    display: none;\n  }\n}\n\n.star {\n  cursor: pointer;\n  margin-inline: var(--ids-rating-star-margin-inline);\n}\n\n.star[icon='star-outlined'] {\n  color: var(--ids-rating-star-color-default);\n\n  &:hover {\n    color: var(--ids-rating-star-color-hover);\n  }\n\n  &:focus-visible {\n    outline: none;\n    color: var(--ids-rating-star-color-focus);\n  }\n}\n\n.star[icon='star-filled'] {\n  color: var(--ids-rating-star-color-selected);\n\n  &:hover {\n    color: var(--ids-rating-star-color-hover);\n  }\n\n  &:focus-visible {\n    outline: none;\n    color: var(--ids-rating-star-color-focus);\n  }\n}\n\n.star[icon='star-half'] {\n  color: var(--ids-rating-star-color-selected);\n\n  &:hover {\n    color: var(--ids-rating-star-color-hover);\n  }\n\n  &:focus-visible {\n    outline: none;\n    color: var(--ids-rating-star-color-focus);\n  }\n\n  &:dir(rtl) {\n    transform: scaleX(-1);\n  }\n}\n\n:host([readonly]) {\n  .star {\n    cursor: default;\n    pointer-events: none;\n  }\n}\n\n:host([disabled]) {\n  .star {\n    cursor: default;\n    pointer-events: none;\n\n    &[icon] {\n      color: var(--ids-rating-star-disabled-color);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
